export enum SelectionPrefix {
  Theme = 'tag-id',
  Destination = 'destination-code',
  Polygon = 'polygon',
  PolygonId = 'polygon-id',
  HotelCode = 'hotel-code',
  FullText = '',
  AllHotels = 'all-hotels',
}
